export default function NavigationTemplate({ o }) {
  return (
    <div id="menu-left">
      <ul>
        {o.menuItems
          .filter((item) => item.available)
          .map((item) => {
            const activeClass = item.active ? 'current' : '';
            const href = o.app.navigation.currentEnvironment + item.href;
            if (item.href === 'host/#welcome/change-password') {
              return (
                <li class={activeClass}>
                  <a onClick={(e) => o.changePassword(e)}>{item.label}</a>
                </li>
              );
            }
            return (
              <li class={activeClass}>
                <a href={href}>{item.label}</a>
              </li>
            );
          })}
      </ul>
    </div>
  );
}
